"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _formik = require("formik");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Wrapper = function Wrapper(_ref) {
  var _profile$contactPermi, _profile$contactPermi2, _profile$contactPermi3, _profile$contactPermi4, _profile$contactPermi5, _profile$contactPermi6, _profile$dataSharePer, _profile$dataSharePer2, _profile$dataSharePer3, _profile$dataSharePer4, _profile$dataSharePer5, _profile$dataSharePer6, _profile$dataSharePer7, _profile$dataSharePer8, _profile$dataSharePer9, _profile$dataSharePer10, _profile$dataSharePer11, _profile$dataSharePer12;

  var translations = _ref.translations,
      profile = _ref.profile,
      onError = _ref.onError,
      onProfileSaveSuccess = _ref.onProfileSaveSuccess,
      hidePushNotifcationCheckbox = _ref.hidePushNotifcationCheckbox,
      hideSmsCheckbox = _ref.hideSmsCheckbox,
      hideEmailCheckbox = _ref.hideEmailCheckbox,
      hideCheckAllCheckbox = _ref.hideCheckAllCheckbox,
      tenantDetails = _ref.tenantDetails;

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting,
        resetForm = _ref2.resetForm;

    var params = _objectSpread(_objectSpread({}, profile), {}, {
      agreedTerms: true,
      contactPermissions: {
        inAppNotificationsAccepted: values.pushNotification,
        smsNotificationsAccepted: values.sms,
        emailNotificationsAccepted: values.email
      },
      dataSharePermissions: {
        partnerEmailAccepted: values.email,
        partnerSmsAccepted: values.sms,
        partnerNotificationAccepted: values.partnerNotificationAccepted,
        affiliateNotificationAccepted: values.affiliateNotificationAccepted
      }
    });

    _axios.default.put("/me", params).then(function (_ref3) {
      var data = _ref3.data;
      resetForm({
        values: values,
        touched: false
      });
      setSubmitting(false);
      onProfileSaveSuccess();
    }).catch(function (_ref4) {
      var response = _ref4.response;
      setSubmitting(false);
      onError(response);
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
    initialValues: {
      pushNotification: profile === null || profile === void 0 ? void 0 : (_profile$contactPermi = profile.contactPermissions) === null || _profile$contactPermi === void 0 ? void 0 : _profile$contactPermi.inAppNotificationsAccepted,
      sms: profile === null || profile === void 0 ? void 0 : (_profile$contactPermi2 = profile.contactPermissions) === null || _profile$contactPermi2 === void 0 ? void 0 : _profile$contactPermi2.smsNotificationsAccepted,
      email: profile === null || profile === void 0 ? void 0 : (_profile$contactPermi3 = profile.contactPermissions) === null || _profile$contactPermi3 === void 0 ? void 0 : _profile$contactPermi3.emailNotificationsAccepted,
      allChecked: (profile === null || profile === void 0 ? void 0 : (_profile$contactPermi4 = profile.contactPermissions) === null || _profile$contactPermi4 === void 0 ? void 0 : _profile$contactPermi4.inAppNotificationsAccepted) && (profile === null || profile === void 0 ? void 0 : (_profile$contactPermi5 = profile.contactPermissions) === null || _profile$contactPermi5 === void 0 ? void 0 : _profile$contactPermi5.smsNotificationsAccepted) && (profile === null || profile === void 0 ? void 0 : (_profile$contactPermi6 = profile.contactPermissions) === null || _profile$contactPermi6 === void 0 ? void 0 : _profile$contactPermi6.emailNotificationsAccepted),
      partnerEmailAccepted: (_profile$dataSharePer = profile === null || profile === void 0 ? void 0 : (_profile$dataSharePer2 = profile.dataSharePermissions) === null || _profile$dataSharePer2 === void 0 ? void 0 : (_profile$dataSharePer3 = _profile$dataSharePer2.find(function (o) {
        return o.type === "PARTNER_EMAIL_ACCEPTED";
      })) === null || _profile$dataSharePer3 === void 0 ? void 0 : _profile$dataSharePer3.value) !== null && _profile$dataSharePer !== void 0 ? _profile$dataSharePer : false,
      partnerSmsAccepted: (_profile$dataSharePer4 = profile === null || profile === void 0 ? void 0 : (_profile$dataSharePer5 = profile.dataSharePermissions) === null || _profile$dataSharePer5 === void 0 ? void 0 : (_profile$dataSharePer6 = _profile$dataSharePer5.find(function (o) {
        return o.type === "PARTNER_SMS_ACCEPTED";
      })) === null || _profile$dataSharePer6 === void 0 ? void 0 : _profile$dataSharePer6.value) !== null && _profile$dataSharePer4 !== void 0 ? _profile$dataSharePer4 : false,
      partnerNotificationAccepted: (_profile$dataSharePer7 = profile === null || profile === void 0 ? void 0 : (_profile$dataSharePer8 = profile.dataSharePermissions) === null || _profile$dataSharePer8 === void 0 ? void 0 : (_profile$dataSharePer9 = _profile$dataSharePer8.find(function (o) {
        return o.type === "PARTNER_NOTIFICATION_ACCEPTED_NAME";
      })) === null || _profile$dataSharePer9 === void 0 ? void 0 : _profile$dataSharePer9.value) !== null && _profile$dataSharePer7 !== void 0 ? _profile$dataSharePer7 : false,
      affiliateNotificationAccepted: (_profile$dataSharePer10 = profile === null || profile === void 0 ? void 0 : (_profile$dataSharePer11 = profile.dataSharePermissions) === null || _profile$dataSharePer11 === void 0 ? void 0 : (_profile$dataSharePer12 = _profile$dataSharePer11.find(function (o) {
        return o.type === "AFFILIATE_NOTIFICATION_ACCEPTED_NAME";
      })) === null || _profile$dataSharePer12 === void 0 ? void 0 : _profile$dataSharePer12.value) !== null && _profile$dataSharePer10 !== void 0 ? _profile$dataSharePer10 : false
    },
    onSubmit: onSubmit,
    children: function children(_ref5) {
      var isValid = _ref5.isValid,
          values = _ref5.values,
          errors = _ref5.errors,
          touched = _ref5.touched,
          dirty = _ref5.dirty,
          handleChange = _ref5.handleChange,
          handleBlur = _ref5.handleBlur,
          handleSubmit = _ref5.handleSubmit,
          isSubmitting = _ref5.isSubmitting,
          setFieldValue = _ref5.setFieldValue,
          setValues = _ref5.setValues,
          resetForm = _ref5.resetForm;

      var handleCheckAllChanged = function handleCheckAllChanged(e) {
        var checked = e.target.checked;
        setValues({
          sms: checked,
          email: checked,
          pushNotification: checked
        });
      }; // const handlePartnerPermissions = (e) => {
      //   if (e.target.checked) {
      //     setValues({
      //       ...values,
      //       partnerNotificationAccepted: true,
      //       partnerEmailAccepted: true,
      //       partnerSmsAccepted: true,
      //     });
      //   } else {
      //     setValues({
      //       ...values,
      //       partnerNotificationAccepted: false,
      //       partnerEmailAccepted: false,
      //       partnerSmsAccepted: false,
      //     });
      //   }
      // };


      var GdprProfile = function GdprProfile() {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowText, {
              isNormal: true,
              children: translations.optInMarketing
            }), !hidePushNotifcationCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
                isSmallerText: true,
                alignItems: "center",
                checked: values.pushNotification,
                label: translations.pushNotification,
                onChange: function onChange(e) {
                  window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                    AppName: process.env.REACT_APP_TITLE
                  }));
                  handleChange(e);
                },
                name: "pushNotification"
              })
            }), !hideSmsCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
                isSmallerText: true,
                alignItems: "center",
                checked: values.sms,
                label: translations.sms,
                onChange: function onChange(e) {
                  window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                    AppName: process.env.REACT_APP_TITLE
                  }));
                  handleChange(e);
                },
                name: "sms"
              })
            }), !hideEmailCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
                isSmallerText: true,
                alignItems: "center",
                checked: values.email,
                label: translations.email,
                onChange: function onChange(e) {
                  window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                    AppName: process.env.REACT_APP_TITLE
                  }));
                  handleChange(e);
                },
                name: "email"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowText, {
              isNormal: true,
              children: translations.optInConsent
            })]
          }), !hideCheckAllCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
              isSmallerText: true,
              alignItems: "center",
              checked: values.pushNotification && values.sms && values.email,
              label: translations.optInCheckAll,
              onChange: function onChange(e) {
                window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                  AppName: process.env.REACT_APP_TITLE
                }));
                handleCheckAllChanged(e);
              }
            })
          })]
        });
      };

      var NonUkPreferences = function NonUkPreferences() {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
              isSmallerText: true,
              name: "sms",
              alignItems: "center",
              label: "Yes! I would like to receive SMS communications to my phone via an autodialer from (or on behalf of) " + (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.complianceName),
              checked: values.sms,
              onChange: function onChange(e) {
                window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                  AppName: process.env.REACT_APP_TITLE
                }));
                handleChange(e);
              },
              onBlur: handleBlur
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
              isSmallerText: true,
              name: "email",
              alignItems: "center",
              checked: values.email,
              label: "Yes, I want to receive email communications from " + (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.complianceName) + " and its selected partners",
              onChange: function onChange(e) {
                window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                  AppName: process.env.REACT_APP_TITLE
                }));
                handleChange(e);
              },
              onBlur: handleBlur
            })
          }), (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.partnerName) !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
              isSmallerText: true,
              name: "partnerNotificationAccepted",
              alignItems: "center",
              checked: values.partnerNotificationAccepted,
              label: "Yes, I would like to receive future promotions from " + (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.partnerName),
              onChange: handleChange,
              onBlur: handleBlur
            })
          }), (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.affiliateName) !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
              isSmallerText: true,
              name: "affiliateNotificationAccepted",
              alignItems: "center",
              checked: values.affiliateNotificationAccepted,
              label: "Yes, I would like to receive additional information and special offers from " + (tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.affiliateName),
              onChange: handleChange,
              onBlur: handleBlur
            })
          })]
        });
      };

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Card, {
        padding: "0 1rem 1rem",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.CardTitle, {
          children: translations.contactPermission
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_formik.Form, {
          children: [profile !== null && profile !== void 0 && profile.nonUkUser ? /*#__PURE__*/(0, _jsxRuntime.jsx)(NonUkPreferences, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(GdprProfile, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
            disabled: !dirty,
            isLoading: isSubmitting,
            isSmall: true,
            onClick: handleSubmit,
            children: translations.saveChanges
          })]
        })]
      });
    }
  });
};

var _default = Wrapper;
exports.default = _default;